import api from "../../../../helpers/api"

export const getMySupplierPublicInquiry = (body) => api.post('/public-supplier-inquiry/get-single-public-supplier-inquiry/' , {...body})


export const getMySupplierPublicInquiries = (body) => api.post('/public-supplier-inquiry/search-public-supplier-inquiries/', body)


export const addSupplierPublicProposal = (body) => api.post(`public-supplier-inquiry/add-public-supplier-proposal`, {...body})

export const addStagingSupplierPublicProposal = (body) => api.post(`public-supplier-staging-proposals/create`, {...body})

export const editSupplierPublicProposal = (body) => api.post(`public-supplier-inquiry/edit-public-supplier-proposal`, {...body})

export const editStagingSupplierPublicProposal = (body) => api.post(`public-supplier-staging-proposals/update`, {...body})

export const deleteSupplierPublicProposal = (body) => api.post(`/public-supplier-inquiry/rem-public-supplier-proposal`, {...body})